import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/Createapi.js";
import "./Loginpage.css";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaArrowRight, FaBolt, FaShieldAlt, FaHeadset, FaWifi } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";

function Loginpage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const res = await API.post("/login.php", {
                username,
                password,
            });
            if (res.data.status === "success") {
                const role = res.data.user.role;
                sessionStorage.setItem("role", role);
                sessionStorage.setItem("username", res.data.user.username);
                sessionStorage.setItem("status", res.data.user.status);
                sessionStorage.setItem("fullname", res.data.user.fullname);
                sessionStorage.setItem("email", res.data.user.email);
                sessionStorage.setItem("mobile", res.data.user.mobile);
                sessionStorage.setItem("loginTime", Date.now());

                toast.success("Login Successful!");
                setTimeout(() => {
                    if (role === "admin") {
                        navigate("/admin");
                    } else {
                        navigate("/user");
                    }
                }, 1000);
            } else {
                setError("Invalid Username or Password");
                toast.error("Invalid Username or Password");
            }
        } catch (err) {
            console.error(err);
            setError("Server Error. Please try again later.");
            toast.error("Server Connection Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            {loading && <Loader />}

            <div className="auth-card">
                {/* Left side: Brand Showcase */}
                <div className="auth-hero-banner">
                    <div className="auth-hero-glow auth-glow-1"></div>
                    <div className="auth-hero-glow auth-glow-2"></div>

                    <div className="auth-hero-content">
                        <div className="auth-brand-text-logo">
                            RiTU <span>BROAD BAND</span>
                        </div>

                        <h2 className="auth-hero-title">Ultra-Fast Fiber Internet</h2>
                        <p className="auth-hero-desc">
                            Connect to seamless high-speed internet, manage your subscription, and track payments instantly.
                        </p>

                        <div className="auth-features-list">
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaBolt /></div>
                                <span>High-Speed Bandwidth up to 1 Gbps</span>
                            </div>
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaShieldAlt /></div>
                                <span>99.9% Uptime Guarantee</span>
                            </div>
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaHeadset /></div>
                                <span>24/7 Priority Customer Support</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right side: Login Form */}
                <div className="auth-form-panel">
                    <div className="auth-header">
                        <h2>Welcome Back</h2>
                        <p>Sign in to your Ritu Broad band account</p>
                    </div>

                    <form onSubmit={handleLogin} className="auth-form">
                        <div className="input-group">
                            <label htmlFor="username">Username or Mobile Number</label>
                            <div className="input-field-wrapper">
                                <span className="input-field-icon"><FaUser /></span>
                                <input
                                    id="username"
                                    type="text"
                                    placeholder="Enter your username or mobile number"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="label-with-link">
                                <label htmlFor="password">Password</label>
                                <span
                                    className="forgot-link-text"
                                    onClick={() =>
                                        navigate("/forgot-password", {
                                            state: { from: "/login" }
                                        })
                                    }
                                >
                                    Forgot Password?
                                </span>
                            </div>
                            <div className="input-field-wrapper">
                                <span className="input-field-icon"><FaLock /></span>
                                <input
                                    id="password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <span
                                    className="password-toggle-btn"
                                    onClick={() => setShowPassword(!showPassword)}
                                    title={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>

                        {error && <div className="auth-error-banner">{error}</div>}

                        <button type="submit" className="auth-submit-btn" disabled={loading}>
                            {loading ? "Signing in..." : <>Sign In <FaArrowRight /></>}
                        </button>
                    </form>

                    <div className="auth-footer-prompt">
                        <p>
                            New connection?{" "}
                            <span className="auth-action-link" onClick={() => navigate("/")}>
                                <FaWifi style={{ marginRight: "4px" }} /> Request for Wi-Fi Connection
                            </span>
                        </p>
                        <p style={{ fontSize: "0.75rem", color: "#94a3b8", marginTop: "6px" }}>
                            By signing in, you agree to our{" "}
                            <a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer" style={{ color: "#0B72B9", fontWeight: "600", textDecoration: "underline" }}>
                                Terms &amp; Conditions
                            </a>
                        </p>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default Loginpage;